import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import arrowDown from '../../assets/images/arrow-down.png';
import { button } from '../../styles/components/buttons.style';

export const header = css`
  display: flex;
  align-items: center;
  height: 80px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  flex-shrink: 0;
  position: fixed; /* Ensure the navbar is fixed */
  top: 0; /* Position it at the top */
  z-index: 1000; /* Ensure it is above other content */
  background-color: white;
  transition: box-shadow 0.3s ease-in-out;

  @media (min-width: ${breakpoints.lg.up}) {
    padding-left: 80px;
    padding-right: 80px;
  }
`;

export const scrolled = css`
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

export const headerLogo = css`
  img {
    display: block;
    max-width: 100%;

    @media (max-width: ${breakpoints.lg.down}) {
      max-width: 40px;
    }
  }
`;

export const nav = css`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;

export const navMobile = css`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${appColors.white};
  padding-top: 20px;
  z-index: 100;

  &.is-open {
    display: block;
  }
`;

export const dropdown = css`
  &.dropdown {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;

    &::after {
      content: '';
      width: 15px;
      height: 9px;
      margin-top: 1px;
      margin-left: 8px;
      background: url(${arrowDown}) no-repeat top center;
    }
  }
`;

export const navItem = css`
  ${dropdown}
  padding-left: 15px;
  padding-right: 15px;

  @media (max-width: ${breakpoints.lg.down}) {
    &.dropdown {
      display: block;

      &::after {
        position: absolute;
        top: 16px;
        right: 20px;
      }
    }
  }
`;

export const navLink = css`
  display: block;
  font-family: ${fontFamily.fredoka};
  font-size: 16px;
  color: ${appColors.blue800};
  padding: 10px;

  &:not(.no-hover):hover {
    cursor: pointer;
    color: ${appColors.orange};
  }
`;

export const navSubLink = css`
  ${navLink}
  padding: 10px 0;
`;

export const dropdownMenu = css`
  display: none;
  position: absolute;
  top: 40px;
  left: 0;
  background: ${appColors.white};
  min-width: 217px;
  padding: 22px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  white-space: nowrap;

  &.is-active {
    display: block;
  }
`;

export const navSubMenu = css`
  ${dropdownMenu};
  @media (max-width: ${breakpoints.lg.down}) {
    &.dropdown-menu {
      position: static;
      padding: 0 20px;
      box-shadow: none;
      min-width: unset;
    }
  }
`;
export const rightPanel = css`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const coin = css`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-right: 10px;

  @media (min-width: ${breakpoints.lg.up}) {
    margin-right: 50px;
  }

  img {
    margin-right: 10px;
  }
`;

export const profile = css`
  ${dropdown}
  cursor: pointer;

  & > a {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border-color: #2196f3;
    border: 2px solid ${appColors.blue800};
    overflow: hidden;
    transition: border-color 0.3s ease, transform 0.3s ease;

    @media (min-width: ${breakpoints.lg.up}) {
      width: 60px;
      height: 60px;
    }

    &:hover {
      border-color: ${appColors.orange};
      transform: scale(1.1);
    }

    & > img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
      object-fit: cover;
    }
  }
`;

export const profileLink = css`
  ${navSubLink}
display: flex;
align - items: center;

  img {
  margin - right: 10px;
  width: 22px;
}
`;

export const settingsMenu = css`
  ${dropdownMenu}
top: 70px;
left: auto;
right: 0;
`;

export const navBtn = css`
background: transparent;
border: none;
margin - right: 15px;

  &:hover {
  background: transparent;
}

  img {
  display: block;
  width: 24px;
}
`;

export const navCloseBtn = css`
  ${navBtn}
margin - left: auto;
display: block;
`;

export const loginbtn = css`
  ${button}
margin - left: auto;
height: 44px;
padding: 0 22px;
`;

export const loginbtn1 = css`

margin - left: auto;
height: 44px;
padding: 0 22px;
display: inline - flex;
align - items: center;
justify - content: center;
color: ${appColors.orange};
height: 64px;
padding: 0 54px;
font - size: 12px;
text - align: left;
  margin-left: auto;
  height: 44px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${appColors.orange};
  height: 64px;
  padding: 0 54px;
  font-size: 12px;
  text-align: left;
`;

